// src/components/AddOpcionModal.js
import React, { useState } from 'react';
import { Button, Modal, Box, Typography, TextField, Select,MenuItem, FormControl,InputLabel,FormControlLabel, Checkbox, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const AddOpcionModal = ({ open, handleClose, handleAddOpcion }) => {
  const [nombre, setNombre] = useState('');
  const [tipo, setTipo] = useState('');
  const [precio, setPrecio] = useState('');
  const [habilitada, setHabilitada] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddOpcion({
      nombre,
      tipo,
      precio: parseFloat(precio),
      habilitada,
    });
    // Limpia el formulario después de enviar
    setNombre('');
    setTipo('');
    setPrecio('');
    setHabilitada(true);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="h2">
            Agregar Nueva Opción
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <TextField
          margin="normal"
          required
          fullWidth
          label="Nombre de la Opción"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
        />
        <FormControl fullWidth margin="normal" required>
          <InputLabel id="tipo-opcion-label">Tipo de Opción</InputLabel>
          <Select
            labelId="tipo-opcion-label"
            id="tipo-opcion-select"
            value={tipo}
            label="Tipo de Opción"
            onChange={(e) => setTipo(e.target.value)}
          >
            <MenuItem value="Leña">Leña</MenuItem>
            <MenuItem value="Servicio">Servicio</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="normal"
          required
          fullWidth
          label="Precio"
          type="number"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
        />
        <FormControlLabel
          control={<Checkbox checked={habilitada} onChange={(e) => setHabilitada(e.target.checked)} />}
          label="Habilitada"
          sx={{ mt: 1, mb: 2 }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Agregar Opción
        </Button>
      </Box>
    </Modal>
  );
};

export default AddOpcionModal;